<template>
	<div class="col-lg-12">
		<div class="hpanel">
		<br />
			<div class="panel-body">
				
				<div>
					<v-tabs
						v-model="active"
						slider-color="primary"
					>
						<v-tab key="gate_step_1" ripple>
							<small>Step 1 - Guest Details</small>
						</v-tab>
						<v-tab key="gate_step_2" ripple>
							<small>Step 2 - Residency</small>
						</v-tab>
						<v-tab key="gate_step_3" ripple>
							<small>Step 3 - Vehicle Entry Fees</small>
						</v-tab>
						<v-tab key="gate_step_4" ripple>
							<small>Step 4 - Accommodation/Camping</small>
						</v-tab>
						<v-tab key="gate_step_5" ripple>
							<small>Step 5 - Activities</small>
						</v-tab>
						 <v-tab v-if="proofOfResidency.length > 0"
							key="gate_step_6"
							ripple
							>
							<small>Step 6 - Proof of Residency</small>
						</v-tab>
						<v-tab key="gate_step_7" ripple>
							<small>Step 7 - Approval</small>
						</v-tab>
						<v-tab-item key="gate_step_1">
							<v-card flat>
								<v-layout row wrap v-if="route === 'PostponeBooking'">
									<v-flex lg6 md6 sm12 xs12 >
										<v-container fluid>
											<v-autocomplete
												label="Select Tourism Partner/Operator"
												v-model="gate_pass.partner_id"
												:items="allPartners"
												:return-object="true"
												:rules="[v => !!v || 'Item is required']"
												required
												item-text="name"
												item-value="public_id"
												:loading="$loadingTrue"
												@change="applyDiscount"
												 :disabled="true"
											></v-autocomplete>
										</v-container>
									</v-flex>
									<v-flex lg6 md6 sm12 xs12>
										<v-container>
											<v-dialog
												ref="dialog"
												persistent
												v-model="modal1"
												lazy
												full-width
												width="290px"
												:return-value.sync="gate_pass.check_in"
											>
												<v-text-field
													slot="activator"
													label="Check-in"
													v-model="gate_pass.check_in"
													readonly
												></v-text-field>
												<v-date-picker
													v-model="gate_pass.check_in"
													:min="start_date"
													scrollable>
													<v-spacer></v-spacer>
													<v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
													<v-btn :depressed="true" flat color="primary" @click="$refs.dialog.save(gate_pass.check_in),endDate(
																				gate_pass.check_in
																			)">OK</v-btn>
												</v-date-picker>
											</v-dialog>
										</v-container>
									</v-flex>
									<v-flex lg6 md6 sm12 xs12>
										<v-container>
												<v-text-field
													slot="activator"
													label="Check-out"
													v-model="gate_pass.check_out"
													readonly
													:disabled="true"
													@change="updateLocalStorage"
												></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg6 md6 sm12 xs12>
										<v-container fluid>
											<v-autocomplete
												label="Destination"
												v-model="gate_pass.destination"
												:items="allDestinations"
												:rules="[v => !!v || 'Item is required']"
												required
												item-text="destination_name"
												item-value="destination_public_id"
												:loading="$loadingTrue"
												@change="checkDestination"
												:disabled="true"
											></v-autocomplete>
										</v-container>
									</v-flex>
								 
									<v-flex lg6 md6 sm12 xs12>
										<v-container fluid>
											<v-text-field
												label="First Name"
												v-model="gate_pass.first_name"
												 maxlength="39"
												required
												:disabled="true"
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg6 md6 sm12 xs12>
										<v-container fluid>
											<v-text-field
												label="Last Name"
												 maxlength="39"
												v-model="gate_pass.last_name"
												required
												:disabled="true"
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg6 md6 sm12 xs12>
										<v-container fluid>
											<v-text-field
												v-model="gate_pass.promo_code"
												label="Promo Code"
												:disabled="true"
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg6 md6 sm12 xs12>
										<v-container fluid>
											<v-text-field
												v-model="gate_pass.partner_booking_ref"
												label="Booking Ref"
												:disabled="true"
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg6 md6 sm12 xs12>
										<v-container fluid>
											<v-text-field
												v-model="gate_pass.agent_email"
												label="Agent Email"
												:disabled="true"
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg12 md6 sm12 xs12>
										<v-container fluid>
											<v-textarea
												v-model="gate_pass.note"
												label="Notes"
												:disabled="true"
											></v-textarea>
										</v-container>
									</v-flex>
								</v-layout>

								<v-layout v-else row wrap>
									<v-flex lg4 md4 sm12 xs12 v-if="route !== 'NewPartnerBooking'">
										<v-container fluid>
											<v-autocomplete
												label="Select Tourism Partner/Operator"
												v-model="gate_pass.partner_id"
												:items="allPartners"
												:return-object="true"
												:rules="[v => !!v || 'Item is required']"
												required
												item-text="name"
												item-value="public_id"
												:loading="$loadingTrue"
												@change="applyDiscount"
											></v-autocomplete>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-dialog
												ref="dialog"
												persistent
												v-model="modal1"
												lazy
												full-width
												width="290px"
												:return-value.sync="gate_pass.check_in"
											>
												<v-text-field
													slot="activator"
													label="Check-in"
													v-model="gate_pass.check_in"
													readonly
												></v-text-field>
												<v-date-picker
													v-model="gate_pass.check_in"
													:min="start_date"
													scrollable>
													<v-spacer></v-spacer>
													<v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
													<v-btn :depressed="true" flat color="primary" @click="$refs.dialog.save(gate_pass.check_in)">OK</v-btn>
												</v-date-picker>
											</v-dialog>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container>
											<v-dialog
												ref="dialog1"
												persistent
												v-model="modal2"
												lazy
												full-width
												width="290px"
												:return-value.sync="gate_pass.check_out"
											>
												<v-text-field
													slot="activator"
													label="Check-out"
													v-model="gate_pass.check_out"
													readonly
													@change="updateLocalStorage"
												></v-text-field>
												<v-date-picker
													v-model="gate_pass.check_out"
													:min="gate_pass.check_in"
													scrollable>
													<v-spacer></v-spacer>
													<v-btn :depressed="true" flat color="primary" @click="modal2 = false">Cancel</v-btn>
													<v-btn :depressed="true" flat color="primary" @click="$refs.dialog1.save(gate_pass.check_out)">OK</v-btn>
												</v-date-picker>
											</v-dialog>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12 v-if="route === 'NewBooking' || 'EditBooking'">
										<v-container fluid>
											<v-autocomplete
												label="Destination"
												v-model="gate_pass.destination"
												:items="allDestinations"
												:rules="[v => !!v || 'Item is required']"
												required
												item-text="destination_name"
												item-value="destination_public_id"
												:loading="$loadingTrue"
												@change="checkDestination"
												v-if="route === 'NewBooking' || route === 'EditBooking'"
											></v-autocomplete>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12 v-if="route === 'NewPartnerBooking'">
										<v-container fluid>
											<v-autocomplete
												label="Destination"
												v-model="gate_pass.destination"
												:items="allPartnerDestinations"
												:rules="[v => !!v || 'Item is required']"
												required
												item-text="destination_name"
												item-value="destination_id"
												:loading="$loadingTrue"
												@change="checkDestination"
												v-if="route === 'NewPartnerBooking'"
											></v-autocomplete>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container fluid>
											<v-text-field
												label="First Name"
												v-model="gate_pass.first_name"
												required
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container fluid>
											<v-text-field
												label="Last Name"
												v-model="gate_pass.last_name"
												required
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container fluid>
											<v-text-field
												v-model="gate_pass.promo_code"
												label="Promo Code"
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container fluid>
											<v-text-field
												v-model="gate_pass.partner_booking_ref"
												label="Booking Ref"
											></v-text-field>
										</v-container>
									</v-flex>
									<v-flex lg4 md4 sm12 xs12>
										<v-container fluid>
											<v-text-field
												v-model="gate_pass.agent_email"
												label="Agent Email"
											></v-text-field>
										</v-container>
									</v-flex>
									 <v-flex lg4 md4 sm12 xs12>
					<v-container fluid>
					  <v-autocomplete
						label="Mode of Entry"
						v-model="gate_pass.entry_mode"
						:items="allEntryModes"
						item-text="entry_mode_name"
						item-value="entry_mode_public_id"
						@change="findEntryPoints"
						:loading="$loadingTrue"
					  ></v-autocomplete>
					</v-container>
				  </v-flex>
				  <v-flex lg4 md4 sm12 xs12>
					<v-container fluid>
					  <v-autocomplete
						label="Point of Entry"
						v-model="gate_pass.entry_point"
						:items="allEntryPoints"
						item-text="gate_name"
						item-value="gate_public_id"
						:loading="$loadingTrue"
					  ></v-autocomplete>
					</v-container>
				  </v-flex>
				  <v-flex lg4 md4 sm12 xs12 >
					<v-container fluid>
					  <v-text-field
						v-model="gate_pass.mode_registration"
						label="Mode registration Number"
					  ></v-text-field>
					</v-container>
				  </v-flex>
				
									<v-flex lg12 md6 sm12 xs12>
										<v-container fluid>
											<v-textarea
												v-model="gate_pass.note"
												label="Notes"
											></v-textarea>
										</v-container>
									</v-flex>
								</v-layout>
							</v-card>

							<v-layout row wrap >
								<v-flex lg11 md11></v-flex>
								<v-flex lg1 md1 sm6 xs6>
									<v-btn @click="nextTab()" fab round color="primary"><v-icon>navigate_next</v-icon></v-btn>
								</v-flex>
							</v-layout>
						</v-tab-item>
						<v-tab-item key="gate_step_2">
							<table cellpadding="1" cellspacing="1" class="table table-bordered">
								<thead>
								<tr>
									<td>Residency</td>
									<td>Currency</td>
									<td>Amount</td>
									<td>Guests</td>
									<td v-if="route !== 'NewPartnerBooking'">Discount (%)</td>
									<td v-if="route !== 'NewPartnerBooking'">Discount Reason</td>
									<td>Total Amount</td>
								</tr>
								</thead>
								<tbody>
								<tr v-for="(fee, key) in allSchoolConservationFees" :key="'fee'+key">
									<td>{{fee.payment_person}}</td>
									<td>{{$localCurrency}} </td>
									<td>{{$roundOff((convert1(fee.payment_person_currency, fee.payment_person_amount).amount).toFixed(2))}}</td>
									
								<td v-if="route === 'PostponeBooking'"><v-text-field label="Number" type="number" v-model="allSchoolConservationFees[key].payment_guests" :disabled="true"></v-text-field></td>
								<td v-else><v-text-field label="Number" type="number" v-model="allSchoolConservationFees[key].payment_guests">></v-text-field></td>
								 <td v-if="route === 'PostponeBooking'"><v-text-field label="Discount (%)" v-model="allSchoolConservationFees[key].payment_person_discount" required :disabled="true" ></v-text-field></td>
									<td v-else-if="route !== 'NewPartnerBooking'"><v-text-field label="Discount (%)" v-model="allSchoolConservationFees[key].payment_person_discount" required></v-text-field></td>
									
									<td v-if="route === 'PostponeBooking'"><v-text-field label="Discount Reason" v-model="allSchoolConservationFees[key].payment_person_discount_reason" :disabled="true"></v-text-field></td>
									<td v-else-if="route !== 'NewPartnerBooking'"><v-text-field label="Discount Reason" v-model="allSchoolConservationFees[key].payment_person_discount_reason"></v-text-field></td>
									<td><b>{{$localCurrency}} {{$roundOff(convert1(allSchoolConservationFees[key].payment_person_currency, Number(allSchoolConservationFees[key].payment_person_amount) * Number(allSchoolConservationFees[key].payment_guests) * ((100 - allSchoolConservationFees[key].payment_person_discount) / 100)).amount)}}</b></td>
								</tr>
								<tr>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td v-if="route !== 'NewPartnerBooking'"></td>
									<td v-if="route !== 'NewPartnerBooking'"></td>
									<td><h3><strong>{{$localCurrency}} {{$roundOff(schoolConservationTotal)}}</strong></h3></td>
								</tr>
								</tbody>
							</table>
							
							<v-layout row wrap >
								<v-flex lg1 md1 sm6 xs6>
									<v-btn @click="previousTab()" fab round color="secondary"><v-icon>navigate_before</v-icon></v-btn>
								</v-flex>
								<v-flex lg10 md10></v-flex>
								<v-flex lg1 md1 sm6 xs6>
									<v-btn @click="nextTab()" fab round color="primary"><v-icon>navigate_next</v-icon></v-btn>
								</v-flex>
							</v-layout>
						</v-tab-item>
						<v-tab-item key="gate_step_3">
							<vehicle-fees :check_in="gate_pass.check_in" :check_out="gate_pass.check_out"></vehicle-fees>
							<v-layout row wrap >
								<v-flex lg1 md1 sm6 xs6>
									<v-btn @click="previousTab()" fab round color="secondary"><v-icon>navigate_before</v-icon></v-btn>
								</v-flex>
								<v-flex lg10 md10></v-flex>
								<v-flex lg1 md1 sm6 xs6>
									<v-btn @click="nextTab()" fab round color="primary"><v-icon>navigate_next</v-icon></v-btn>
								</v-flex>
							</v-layout>
						</v-tab-item>
						<v-tab-item key="gate_step_4">
							<v-card flat>
								<facility-booking prop-name="chosenFacilities" @chosenFacilities="putFacilityData($event)"></facility-booking>
							</v-card>
							<v-layout row wrap >
								<v-flex lg1 md1 sm6 xs6>
									<v-btn @click="previousTab()" fab round color="secondary"><v-icon>navigate_before</v-icon></v-btn>
								</v-flex>
								<v-flex lg10 md10></v-flex>
								<v-flex lg1 md1 sm6 xs6>
									<v-btn @click="nextTab()" fab round color="primary"><v-icon>navigate_next</v-icon></v-btn>
								</v-flex>
							</v-layout>
						</v-tab-item>
						<v-tab-item key="gate_step_5">
							<v-card flat>
								<inventory-booking prop-name="chosenInventory" @chosenInventory="putActivityData($event)"></inventory-booking>
							</v-card>
							<v-layout row wrap >
								<v-flex lg1 md1 sm6 xs6>
									<v-btn @click="previousTab()" fab round color="secondary"><v-icon>navigate_before</v-icon></v-btn>
								</v-flex>
								<v-flex lg10 md10></v-flex>
								<v-flex lg1 md1 sm6 xs6>
									<v-btn @click="nextTab()" fab round color="primary"><v-icon>navigate_next</v-icon></v-btn>
								</v-flex>
							</v-layout>
						</v-tab-item>
						
						<v-tab-item  v-if="proofOfResidency.length > 0"
							key="gate_step_6"
							>
							<v-card flat>
								<residency-proof></residency-proof>
								<v-layout row wrap>
								<v-flex lg1 md1 sm6 xs6>
									<v-btn @click="previousTab()" fab round color="secondary"
									><v-icon>navigate_before</v-icon></v-btn
									>
								</v-flex>
								<v-flex lg10 md10></v-flex>
								<v-flex lg1 md1 sm6 xs6>
									<v-btn @click="nextTab()" fab round color="primary"
									><v-icon>navigate_next</v-icon></v-btn
									>
								</v-flex>
								</v-layout>
							</v-card>
						</v-tab-item>

						<v-tab-item key="gate_step_7">
							<v-card flat>
								<div class="row">
									<div class="col-md-12">
										<table cellpadding="1" cellspacing="1" class="table table-bordered">
											<thead>
											<tr>
												<td>Entry</td>
												<td>Guests</td>
												<td>Entry Discount</td>
												<td>Total Amount</td>
											</tr>
											</thead>
											<tbody>
											<tr>
												<td><b>Conservation Fees </b> <small> for {{getDays(gate_pass.check_in, gate_pass.check_out)}} days</small></td>
												<td>{{getGroupGuests()}}</td>
												<td>{{gate_pass.tour_operator.conservation_fee_discount}}%</td>
												<td>{{$localCurrency}} {{(schoolNewConservationTotal(gate_pass.tour_operator.conservation_fee_discount)).toLocaleString('en')}}</td>
												
											</tr>
											<tr>
												<table>
													<thead>
													<tr>
														<td>Residency</td>
														<td>No of guests</td>
														<td>Amount</td>
														<td>Discount</td>
													</tr>
													</thead>
													<tbody>
													<tr v-for="(c_fees, idx) in allSchoolConservationFees" :key="'c_fee'+idx">
														<td v-if="c_fees.payment_guests > 0">{{c_fees.payment_person}}</td>
														<td v-if="c_fees.payment_guests > 0">{{c_fees.payment_guests}}</td>
														<td v-if="c_fees.payment_guests > 0">{{$localCurrency}} {{$roundOff(convert1(c_fees.payment_person_currency, c_fees.payment_person_amount).amount.toFixed(2))}}</td>
														<td v-if="c_fees.payment_guests > 0">{{c_fees.payment_person_discount}}%</td>
													</tr>
													</tbody>
												</table>
											</tr>
											<tr>
												<td><b>Vehicle Fees</b> <small> for {{getDays(gate_pass.check_in, gate_pass.check_out)}} days</small></td>
												<td>{{getVehicleTotals()}}</td>
												<td>{{$localCurrency}} {{vehicleTotal.toFixed(2)}}</td>
											</tr>
											<tr>
												<table>
													<thead>
													<tr>
														<td>Vehicle Type</td>
														<td>No of Vehicles</td>
														<td>Amount</td>
														<td>Discount</td>
													</tr>
													</thead>
													<tbody>
													<tr v-for="(v_fees, idx) in allVehicles" :key="'v_fee'+idx">
														<td v-if="v_fees.vehicles > 0">{{v_fees.vehicle_charge_category}}</td>
														<td v-if="v_fees.vehicles > 0">{{v_fees.vehicles}}</td>
														<td v-if="v_fees.vehicles > 0"> {{$localCurrency}} {{$roundOff(convert1(v_fees.vehicle_charge_cost_currency, v_fees.vehicle_charge_category_cost).amount.toFixed(2))}}</td>
														<td v-if="v_fees.vehicles > 0">{{v_fees.discount}}%</td>
													</tr>
													</tbody>
												</table>
											</tr>
											<tr><td><b>Accommodation</b></td></tr>
											<tr v-for="(accommodation, key) in chosenFacilities" :key="'acc'+key">
												<td>{{accommodation.name}}</td>
												<td>{{Number(accommodation.children) + Number(accommodation.adults) + Number(accommodation.extra_pax_adults) + Number(accommodation.extra_pax_children)}}</td>
												<td>{{$localCurrency}} {{$roundOff(facilityTotal(accommodation))}}</td>
											<tr>
											<tr v-if="bookedFacilities.length > 0">
											<tr v-for="(accommodation, key) in bookedFacilities" :key="'accm'+key">
												<td>{{accommodation.facility_name}}</td>
												<td>{{Number(accommodation.facility_booking_children) + Number(accommodation.facility_booking_adults)}}</td>
												<td>{{accommodation.facility_booking_currency}} {{oldFacilityTotal(accommodation)}}</td>
											<tr>
											</tr>
											</tr>

											<tr><td><b>Ol Pejeta Escapes</b></td></tr>
											<tr v-if="chosenExternalFacilities.length > 0">
											<tr v-for="(accommodation, index) in chosenExternalFacilities" :key="'acc'+index">
												<td>{{accommodation.name}}({{accommodation.facility_parameter_name}})</td>
												<td>{{totalExternalGuest(accommodation)}}</td>
												<td>{{ $localCurrency }}
													{{
													   $roundOff(externalFacilityTotal(accommodation))
													}}</td>
											<tr>
											</tr>
											<tr v-if="finExternalFacilities.length > 0">
											<tr v-for="(accommodation, index) in finExternalFacilities" :key="'acc'+index">
													<td>{{accommodation.facility_name}}({{accommodation.pricing_parameter.parameter_name}})</td>
													<td>{{totalOldExternalGuest(accommodation)}}</td>
													<td>{{ $localCurrency }}
													{{
													$roundOff(
														convert1(
														accommodation.facility_booking_currency,
														accommodation.facility_booking_total_cost
														).amount)
													}}</td>
											<tr>
											</tr>
											
											 <tr>
											</tr>

											<tr> <td><b>Activities</b></td></tr>
											<tr v-for="(activity, key) in chosenInventory" :key="'act'+key">
												<td>{{activity.name}}</td>
												<td>{{Number(activity.children) + Number(activity.adults) + Number(activity.extra_pax_children) + Number(activity.extra_pax_adults)}}</td>
												<td>{{$localCurrency}} {{findActivityTotal(activity).toFixed(2)}}</td>
											<tr>
											</tr>
											<tr v-if="bookedInventory.length > 0">
												<tr v-for="(activity, key) in bookedInventory" :key="'ac'+key">
													<td>{{activity.inventory_name}}</td>
													<td>{{Number(activity.inventory_booking_children) + Number(activity.inventory_booking_adults)}}</td>
													<td>{{activity.inventory_booking_currency}} {{activity.inventory_booking_total_cost}}</td>
												</tr>
											</tr>
											 <tr></tr>

													<tr v-if="proofOfResidency.length > 0">
													<td>
														<b>Proof Of residency </b>
													</td>
													</tr>
													<tr v-if="proofOfResidency.length > 0">
													<table>
														<thead>
														<tr>
															<td>First Name</td>
															<td>Last Name</td>
															<td>Residency</td>
															<td>Document Id</td>
														</tr>
														</thead>
														<tbody>
														<tr
															v-for="(proof, idx) in proofOfResidency"
															:key="'proof' + idx"
														>
															
															<td v-if="proof.first_name != '' && proof.last_name!='' &&  proof.document_id!='' " >
															{{ proof.first_name }}
															</td>
															<td v-if="proof.first_name != '' && proof.last_name!='' &&  proof.document_id!='' " >
															{{ proof.last_name }}
															</td>
															<td v-if="proof.first_name != '' && proof.last_name!='' &&  proof.document_id!='' ">{{ proof.payment_person }}</td>
															<td v-if="proof.first_name != '' && proof.last_name!='' &&  proof.document_id!='' ">
															{{ proof.document_id}}
															</td>
															
														</tr>
														</tbody>
													</table>
													</tr>
											<tr><td><b>Destination : </b> {{this.gate_pass.destination_name}} </td></tr>
											<tr>
												<td><h4>Total</h4></td>
												<td></td>
												<td><h4>{{$localCurrency}} {{totalPrice.toLocaleString('en')}}</h4></td>
											</tr>
											</tbody>
										</table>
									</div>
									<div class="col-md-12">
										<div class="form-group">
											<div class="col-md-4 col-lg-offset-2" v-if="route === 'EditBooking'">
												<v-switch
													v-model="gate_pass.send_mail"
													label="Send Email to client"
												>
												</v-switch>
											</div>
											<div class="col-sm-8" v-if="route === 'NewPartnerBooking'">
												<!-- <v-btn :depressed="true" color="primary"  @click.prevent="gate_pass.payment_period = 0, doBooking()" :loading="this.$store.state.LoadingStore.loading">Complete Booking (Paid before Entry)</v-btn>
												<v-btn :depressed="true" color="info"  @click.prevent="gate_pass.payment_period = 1, doBooking()" :loading="this.$store.state.LoadingStore.loading">Complete Booking (Paid later)</v-btn> -->
												<v-btn :depressed="true" color="primary"  @click.prevent="gate_pass.payment_period = 0, doBooking()" :loading="this.$store.state.LoadingStore.loading">Complete Booking (Guest To Pay)</v-btn>
												<v-btn :depressed="true" color="info"  @click.prevent="gate_pass.payment_period = 1, doBooking()" :loading="this.$store.state.LoadingStore.loading">Complete Booking ({{partner_name}} To Pay)</v-btn>
											</div>
											<div class="col-sm-12 " v-if="route === 'NewBooking'">
											<v-btn :depressed="true" color="primary"  @click.prevent="gate_pass.payment_period = 0, doBooking()" :loading="this.$store.state.LoadingStore.loading">Complete Booking (Guest To Pay)</v-btn>
												<v-btn :depressed="true" color="info"  @click.prevent="gate_pass.payment_period = 1, doBooking()" :loading="this.$store.state.LoadingStore.loading">Complete Booking ({{partner_name}} To Pay)</v-btn>
												<!-- <v-btn :depressed="true" color="default"  @click.prevent="gate_pass.payment_period = 3, doBooking()" :loading="this.$store.state.LoadingStore.loading">Complete Booking (To Invoice)</v-btn> -->
												<!-- <v-btn :depressed="true" color="primary"  @click.prevent="gate_pass.payment_period = 0, doBooking()" :loading="this.$store.state.LoadingStore.loading">Complete Booking (Paid before Entry)</v-btn>
												<v-btn :depressed="true" color="info"  @click.prevent="gate_pass.payment_period = 1, doBooking()" :loading="this.$store.state.LoadingStore.loading">Complete Booking (Paid later)</v-btn>
												<v-btn :depressed="true" color="default"  @click.prevent="gate_pass.payment_period = 3, doBooking()" :loading="this.$store.state.LoadingStore.loading">Complete Booking (To Invoice)</v-btn> -->
											</div>
											<div class="col-md-6" v-if="route === 'EditBooking'">

												<v-btn color="info" @click.prevent="gate_pass.payment_period = 0, doModifyBooking()" :loading="this.$store.state.LoadingStore.loading">Amend Booking</v-btn>
											</div>
											<div class="col-md-6" v-if="route === 'PostponeBooking'">
												<v-btn color="info" @click.prevent="gate_pass.payment_period = 0, postponeBooking()" :loading="this.$store.state.LoadingStore.loading">Postpone Booking</v-btn>
											</div>
										</div>
									</div>
								</div>
							</v-card>
							<v-snackbar
								:multi-line="true"
								:right="true"
								:vertical="true"
								:timeout="6000"
								color="error"
								v-model="snackbar">
								Destination must be provided
								<v-btn
									flat
									@click="snackbar = false">
									Close
								</v-btn>
							</v-snackbar>
						</v-tab-item>
						
					</v-tabs>
				</div>
			</div>
		</div>
		{{conservationFeesProofData}}
		{{updatePartnerBooking}}
		
	</div>
</template>

<script>
import FacilityBooking from "./FacilityBooking";
import Datepicker from "vuejs-datepicker";
import InventoryBooking from "./InventoryBooking";
import ConservationFees from "./ConservationFees";
import VehicleFees from "./VehicleFees";
import ResidencyProof from "./ResidencyProof";
export default {
  components: {
    VehicleFees,
    ConservationFees,
    InventoryBooking,
    FacilityBooking,
    Datepicker,
    "residency-proof": ResidencyProof,
  },
  name: "gate-entry-ticket",
  data() {
    return {
      start_date: this.$moment().format("YYYY-MM-DD"),
      backdate_today: this.$moment().subtract(7, "d").format("YYYY-MM-DD"),
      route: this.$route.name,
      active: null,
      requiredRules: [(v) => !!v || "This field is required"],
      snackbar: false,
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      gate_pass: {
        payment_period: 0,
        checking_in: "",
        tour_operator: {
          conservation_fee_discount: 0,
        },
        partner_booking_ref: "",
        currency: "",
        currency_id: "",
        type: "PB001A20",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        destination: "",
        check_in: this.$moment().format("YYYY-MM-DD"),
        check_out: this.$moment().format("YYYY-MM-DD"),
        session_id: localStorage.getItem("lkjhgfdsa"),
        promo_code: "",
        partner_id: "",
        agent_email: "",
        destination_name: "",
        note: "",
        send_mail: "",
        entry_mode: "",
        entry_point: "",
        mode_registration: "",
       
      },
     
      selectAccomodation: [],
      selectedActivities: [],
      partner_name: "",
    };
  },
  created() {
    if (this.route === "NewPartnerBooking") {
      this.$store.dispatch(
        "get_partner",
        JSON.parse(localStorage.getItem("unem")).instiution_id
      );
      this.partner_name = JSON.parse(
        localStorage.getItem("unem")
      ).instiution_name;
      this.$store.dispatch(
        "get_institution_destinations",
        JSON.parse(localStorage.getItem("unem")).instiution_id
      );
    } else {
      this.$store.dispatch("get_all_partners");
    }
    this.$store.dispatch("get_all_destinations");
    this.$store.dispatch("get_all_gates");
    this.$store.dispatch("get_all_entry_modes");
  },
  computed: {
    allEntryPoints: function () {
      let allEntry = this.allGates;

      let res = [];
      if (this.gate_pass.entry_mode != "") {
        for (let i = 0; i < allEntry.length; i++) {
          if (allEntry[i].entry_mode_public_id == this.gate_pass.entry_mode) {
            res.push(allEntry[i]);
          }
        }
      }

      return res;
    },
    currency: function () {
      return this.$store.state.CurrencyStore.browser_currency;
    },
    conservationDiscount: function () {
      var conservationFeeDiscount = 0;
      let conservationDiscount =
        this.gate_pass.tour_operator.conservation_fee_discount;
      if (conservationDiscount === undefined) {
        conservationFeeDiscount = 0;
      } else {
        conservationFeeDiscount = Number(conservationDiscount);
      }
      var conservationFees = this.allSchoolConservationFees;
      var size = conservationFees.length;
      var total = 0;
      for (var i = 0; i < size; i++) {
        total =
          total +
          this.convert1(
            conservationFees[i].payment_person_currency,
            conservationFees[i].payment_person_amount
          ).amount *
            Number(conservationFees[i].payment_guests) *
            ((100 - conservationFees[i].payment_person_discount) / 100);
      }
      total =
        total * this.getDays(this.gate_pass.check_in, this.gate_pass.check_out);
      if (conservationDiscount > 0) {
        // (100 - 7.05)/100 * 1200
        total = ((100 - conservationDiscount) / 100) * total;
      }
      return Math.ceil(total);
    },
    conservationDifference: function () {
      return this.conservationDiscount;
    },
    totalPrice: function () {
      // activity total
      var activity = 0;
      for (var i = 0; i < this.chosenInventory.length; i++) {
        activity = activity + this.activityDifference(this.chosenInventory[i]);
      }
      for (var x = 0; x < this.bookedInventory.length; x++) {
        activity =
          activity + this.findOldActivityTotal(this.bookedInventory[x]);
      }
      // facility total
      var facility = 0;
      var external_facility = 0;
      var old_external_facility = 0;
      for (var j = 0; j < this.chosenFacilities.length; j++) {
        facility = facility + this.facilityDifference(this.chosenFacilities[j]);
      }
      for (var f = 0; f < this.bookedFacilities.length; f++) {
        facility = facility + this.oldFacilityTotal(this.bookedFacilities[f]);
      }
      if (this.chosenExternalFacilities.length > 0) {
        for (var k = 0; k < this.chosenExternalFacilities.length; k++) {
          external_facility =
            external_facility +
            this.externalFacilityTotal(this.chosenExternalFacilities[k]);
        }
      }
      if (this.finExternalFacilities.length > 0) {
        for (var m = 0; m < this.finExternalFacilities.length; m++) {
          let amount = this.convert1(
            this.finExternalFacilities[m].facility_booking_currency,
            this.finExternalFacilities[m].facility_booking_total_cost
          ).amount;
          old_external_facility = old_external_facility + amount;
        }
      }
      // vehicle total
      var vehicleData = this.vehicleTotal;
      // conservation total
      var conservationData = this.conservationDifference;
      return (
        activity +
        facility +
        vehicleData +
        conservationData +
        Number(external_facility) +
        Number(old_external_facility)
      );
    },
    disabled_settings: function () {
      var startDate = this.$moment().format("YYYY-MM-DD");
      return {
        to: new Date(this.$moment(startDate).format("YYYY, MM, DD")),
      };
    },
  },
  methods: {
    nextTab() {
      this.active = Number(this.active + 1);
    },
    previousTab() {
      this.active = Number(this.active - 1);
    },
    applyDiscount(partner) {
      this.partner_name = partner.name;
      this.gate_pass.tour_operator.conservation_fee_discount = Number(
        partner.conservation_fee_discount
      );
    },
    checkDestination(publicId) {
      // Query for the Pricing Schedule
      var data = {
        check_in_date: this.gate_pass.check_in,
        check_out_date: this.gate_pass.check_out,
        destination: this.gate_pass.destination,
      };
      this.$store.dispatch("get_newly_scheduled_school_pricing", data);
      var instance = this;
      if (this.route === "NewBooking") {
        this.allDestinations.map((destination) => {
          if (publicId === destination.destination_public_id) {
            instance.gate_pass.destination_name = destination.destination_name;
          }
        });
      } else {
        this.allPartnerDestinations.map((destination) => {
          if (publicId === destination.partner_destination_public_id) {
            instance.gate_pass.destination_name = destination.destination_name;
          }
        });
      }
    },
    updateLocalStorage() {
      localStorage.setItem("check_in", this.gate_pass.check_in);
      localStorage.setItem("check_out", this.gate_pass.check_out);
    },
    getVehicleTotals: function () {
      var allVehicles = this.allVehicles;
      var size = allVehicles.length;
      var vehicles = 0;
      for (var i = 0; i < size; i++) {
        vehicles = Number(vehicles) + Number(allVehicles[i].vehicles);
      }
      return vehicles;
    },
    putFacilityData: function (data) {
      this.selectAccomodation = data;
    },
    putActivityData: function (data) {
      this.selectedActivities = data;
    },
    doModifyBooking: function () {
      this.$store.dispatch("loading_true");
      this.gate_pass.currency_id =
        this.$store.state.CurrencyStore.browser_currency_id;
      this.gate_pass.currency =
        this.$store.state.CurrencyStore.browser_currency_id;
      var data1 = {
        guests: this.allConservationFees,
        facilities: this.chosenFacilities,
        external_facilities: this.chosenExternalFacilities,
        inventory: this.chosenInventory,
        vehicles: this.allVehicles,
        partner: this.gate_pass.partner_id,
        booking_id: this.$route.params.booking_id,
        old_facilities: this.bookedFacilities,
        old_external_facilities: this.finExternalFacilities,
        old_inventory: this.bookedInventory,
        updated_bookings: this.bookedFacilities,
        multi: this.addedMultiArrivals,
        proof_of_residency: this.proofOfResidency,
      };
      Object.assign(data1, this.gate_pass);
      this.$store.dispatch("modify_partner_booking", data1);
    },

    postponeBooking: function () {
      this.$store.dispatch("loading_true");
      this.gate_pass.currency_id =
        this.$store.state.CurrencyStore.browser_currency_id;
      this.gate_pass.currency =
        this.$store.state.CurrencyStore.browser_currency_id;

      let postponeFac = JSON.parse(
        localStorage.getItem("postponed_facility_data")
      );
      let postExternalponeFac = JSON.parse(
        localStorage.getItem("postponed_external_facility_data")
      );

      let postponeInvent = JSON.parse(
        localStorage.getItem("postponed_inventory_data")
      );

      if (postponeFac == null) {
        postponeFac = [];
      } else {
        postponeFac = postponeFac;
      }
      if (postExternalponeFac == null) {
        postExternalponeFac = [];
      } else {
        postExternalponeFac = postExternalponeFac;
      }
      if (postponeInvent == null) {
        postponeInvent = [];
      } else {
        postponeInvent = postponeInvent;
      }

      for (var i = 0; i < this.bookedFacilities.length; i++) {
        let booked_facilities = this.bookedFacilities[i];
        booked_facilities["facility_booking_check_out_date"] = this.$moment(
          booked_facilities.facility_booking_check_out_date
        ).format("YYYY-MM-DD");
        booked_facilities["facility_booking_check_in_date"] = this.$moment(
          booked_facilities.facility_booking_check_in_date
        ).format("YYYY-MM-DD");
      }

      for (var i = 0; i < this.bookedExternalFacilities.length; i++) {
        let booked_external_facilities = this.bookedExternalFacilities[i];

        booked_external_facilities["facility_booking_check_out_date"] =
          this.$moment(
            booked_external_facilities.facility_booking_check_out_date
          ).format("YYYY-MM-DD");

        booked_external_facilities["facility_booking_check_in_date"] =
          this.$moment(
            booked_external_facilities.facility_booking_check_in_date
          ).format("YYYY-MM-DD");

        let facility_external_bookings =
          booked_external_facilities.facility_bookings;
        for (var j = 0; j < facility_external_bookings.length; j++) {
          let external_bookings = facility_external_bookings[j];
          external_bookings["facility_booking_check_out_date"] = this.$moment(
            external_bookings.facility_booking_check_out_date
          ).format("YYYY-MM-DD");

          external_bookings["facility_booking_check_in_date"] = this.$moment(
            external_bookings.facility_booking_check_in_date
          ).format("YYYY-MM-DD");
        }
      }

      for (var k = 0; k < this.bookedInventory.length; k++) {
        let booked_inventories = this.bookedInventory[k];
        booked_inventories["inventory_booking_date"] = this.$moment(
          booked_inventories.inventory_booking_date
        ).format("YYYY-MM-DD");
      }

      var data = {
        booking_id: this.$route.params.booking_id,
        guests: this.allConservationFees,
        facilities: postponeFac,
        external_facilities: postExternalponeFac,
        inventory: this.bookedInventory,
        vehicles: this.allVehicles,
        old_facilities: JSON.parse(localStorage.getItem("old_facility_data")),
        old_inventory: JSON.parse(localStorage.getItem("old_activity_data")),
        updated_facilities: this.bookedFacilities,
        updated_external_facilities: this.bookedExternalFacilities,
        multi: this.addedMultiArrivals,
      };
      Object.assign(data, this.gate_pass);
      this.$store.dispatch("postpone_booking", data);
    },
    doBooking: function () {
      if (this.gate_pass.destination === "") {
        this.snackbar = true;
      } else {
        this.$store.dispatch("loading_true");
        if (this.route === "NewPartnerBooking") {
          this.gate_pass.currency_id =
            this.$store.state.CurrencyStore.browser_currency_id;
          this.gate_pass.currency =
            this.$store.state.CurrencyStore.browser_currency_id;
          this.gate_pass.tour_operator = JSON.parse(
            localStorage.getItem("unem")
          ).instiution_id;
          var data = {
            guests: this.allSchoolConservationFees,
            facilities: this.chosenFacilities,
            external_facilities: this.chosenExternalFacilities,
            inventory: this.chosenInventory,
            vehicles: this.allVehicles,
            partner: JSON.parse(localStorage.getItem("unem")).instiution_id,
            proof_of_residency: this.proofOfResidency,
          };
          Object.assign(data, this.gate_pass);
          this.$store.dispatch("post_partner_booking", data);
        } else {
          this.gate_pass.currency_id =
            this.$store.state.CurrencyStore.browser_currency_id;
          this.gate_pass.currency =
            this.$store.state.CurrencyStore.browser_currency_id;
          var data2 = {
            guests: this.allSchoolConservationFees,
            facilities: this.chosenFacilities,
            external_facilities: this.chosenExternalFacilities,
            inventory: this.chosenInventory,
            vehicles: this.allVehicles,
            partner: this.gate_pass.partner_id.public_id,
            multi: this.addedMultiArrivals,
            proof_of_residency: this.proofOfResidency,
          };
          Object.assign(data2, this.gate_pass);
          this.$store.dispatch("post_partner_booking", data2);
        }
      }
    },
    putStartDate: function () {
      var date = this.gate_pass.check_in;
      date = this.$moment(date).format("YYYY-MM-DD");
      this.gate_pass.check_in = date;
    },
    putEndtDate: function () {
      var date = this.gate_pass.check_out;
      date = this.$moment(date).format("YYYY-MM-DD");
      this.gate_pass.check_out = date;
    },
    currencyChange: function () {
      var data = this.currency;
      localStorage.setItem("currency", data);
      this.$store.state.CurrencyStore.browser_currency = data;
    },
    endDate(data) {
      let currentBooking = this.$store.state.BookingStore.booking;
      let instance = this;
      let bookingStartDate = currentBooking.booking_check_in_date;

      let bookingEndDate = currentBooking.booking_check_out_date;
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const firstDate = new Date(bookingStartDate);
      const secondDate = new Date(bookingEndDate);
      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
      let postponedCheckInDate = new Date(instance.gate_pass.check_in);

      let postponedCheckOutDate = postponedCheckInDate.setDate(
        postponedCheckInDate.getDate() + diffDays
      );
      let postponedCheckOutDateFormatted = new Date(postponedCheckOutDate);
      instance.gate_pass.check_out = this.$moment(postponedCheckOutDate).format(
        "YYYY-MM-DD"
      );
    },
    findEntryPoints: function () {
    
      this.allEntryPoints;
    },
  },
};
</script>

<style scoped>
</style>
